export const transition = {
  ease: 'easeOut',
  bounce: 0,
  duration: 0.2
}
export const TOP_OFFSET = 50
export const LEFT_OFFSET = 60

export const measurements = {
  topOffset: (desktop, value) => {
    if (!desktop) {
      return 0
    }

    const ratio = value / TOP_OFFSET
    return TOP_OFFSET * (1 - ratio)
  },
  leftOffset: (desktop, value) => {
    if (!desktop) {
      return 20
    }

    const ratio = value / TOP_OFFSET
    return LEFT_OFFSET * (1 - ratio)
  },
  borderRadius: (desktop, value) => {
    const radius = desktop ? 30 : 15
    const ratio = value / TOP_OFFSET
    return radius * (1 - ratio)
  },
  arrowOffset: (desktop, value) => {
    const ratio = value / TOP_OFFSET
    const width = 45
    const offset = LEFT_OFFSET + 0.5 * width
    return offset * ratio
  }
}